import React, { useState, useEffect } from "react";
import DataTable from "examples/Tables/DataTable";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import api from "../../api/axios"; // 🔁 ton axios configuré avec X-Tenant

const AllSales = () => {
  const [sales, setSales] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchSales = async () => {
      setLoading(true);
      try {
        const response = await api.get("/quickbooks/sales/");
        const rawSales = response.data.all_sales?.QueryResponse?.SalesReceipt || [];
        setSales(rawSales);
      } catch (err) {
        console.error("❌ Erreur récupération ventes :", err);
      } finally {
        setLoading(false);
      }
    };

    fetchSales();
  }, []);

  const calculateStatus = (sale) => {
    if (sale.Balance === 0) return "Closed";

    const today = new Date();
    const dueDate = new Date(sale.TxnDate);
    dueDate.setDate(dueDate.getDate() + 30); // Ex : 30 jours de délai

    const remainingDays = Math.ceil((dueDate - today) / (1000 * 60 * 60 * 24));
    return remainingDays > 0
      ? `Due in ${remainingDays} days`
      : `Overdue by ${Math.abs(remainingDays)} days`;
  };

  const columns = [
    { Header: "DATE", accessor: "TxnDate", align: "left" },
    { Header: "TYPE", accessor: "type", align: "left" },
    { Header: "NO.", accessor: "DocNumber", align: "left" },
    { Header: "CUSTOMER", accessor: "CustomerRef.name", align: "left" },
    { Header: "MEMO", accessor: "CustomerMemo.value", align: "left" },
    { Header: "AMOUNT", accessor: "TotalAmt", align: "right" },
    {
      Header: "STATUS",
      accessor: "status",
      align: "center",
      Cell: ({ row }) => calculateStatus(row.original),
    },
    { Header: "ACTION", accessor: "action", align: "center" },
  ];

  const rows = sales.map((sale) => ({
    TxnDate: sale.TxnDate,
    type: sale.PaymentMethodRef?.name || "N/A",
    DocNumber: sale.DocNumber,
    CustomerRef: { name: sale.CustomerRef?.name || "N/A" },
    CustomerMemo: { value: sale.CustomerMemo?.value || "N/A" },
    TotalAmt: sale.TotalAmt,
    status: calculateStatus(sale),
    action: "View Details",
  }));

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <DataTable table={{ columns, rows }} isLoading={loading} noEndBorder />
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default AllSales;
